import React from "react";

const Clock = ({ idSuffix = "" }) => {
  const idToAdd = `lt-clock-icon${idSuffix ? `-${idSuffix}` : ""}`;
  return (
    <svg
      aria-hidden={true}
      aria-labelledby={idToAdd}
      role="img"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={idToAdd}>Test Duration</title>
      <g>
        <path
          d="M8 4.66667V8H11.3333M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14Z"
          stroke="#666666"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default Clock;
